import { lightGreen, lightRed } from 'styles'

import { makeStyles } from '@mui/styles'

const TEXT_OVERFLOW_STYLES = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const shared = {
  alignItems: 'center',
  display: 'flex',
  fontWeight: '600',
}

interface Props {
  color: string
}

export default makeStyles({
  root: {
    '&.info': {
      fontSize: '0.875rem',
      display: 'inline-block',
    },
    '& .info_percent-difference': {
      ...shared,
      display: 'inline-block',
    },
    '& .info_percent-difference.is-positive': {
      color: ({ color }: Props) => color || lightGreen,
    },
    '& .info_percent-difference.is-zero': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '& .info_percent-difference.is-negative': {
      color: lightRed,
    },
    '& .info-label': {
      ...TEXT_OVERFLOW_STYLES,
      maxWidth: '3rem',
    },
    '& .info-value': {
      ...shared,
      padding: '0 0.5rem',
    },
  },
})
